export default __webpack_public_path__ + "static/media/emenu-bg.614564bf.webp";